// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-publishers-table {
  margin-bottom: 2rem;
}

.add-administrator-button {
  width: fit-content;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/WorkScenes/Steps/PublishersSteps/PublishersStep/AddPublishersArea/AddPublishersTable/index.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;AACF","sourcesContent":[".add-publishers-table {\n  margin-bottom: 2rem;\n}\n\n.add-administrator-button {\n  width: fit-content;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
